//import { BranchModule } from './branch/branch.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule as MkAccordionModule, BoxModule, LayoutModule } from 'angular-admin-lte';
import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { NumberPickerModule } from 'ng-number-picker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxFileDragDropModule } from 'ngx-file-drag-drop';
import { TagifyModule } from 'ngx-tagify';
import { adminLteConf } from 'src/app/admin-lte.conf';
import { AppComponent } from 'src/app/app.component';
import { CoreModule } from 'src/app/core/core.module';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { ApiService } from 'src/app/core/services/base/api.service';
import { JwtService } from 'src/app/core/services/base/jwt.service';
import { OrderService } from 'src/app/core/services/order.service';
import { HomeComponent } from 'src/app/home/home.component';
import { ProductPromotionComponent } from 'src/app/pages/product-promotion/product-promotion.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DeliveryModule } from './delivery/delivery.module';
import { OrdersModule } from './orders/orders.module';
import { PagesRoutingModule } from './page-routing.module';
import { PageComponent } from './page.component';

@NgModule({
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthGuard,
    ApiService,
    JwtService,
    OrderService,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    CoreModule,
    LoadingPageModule,
    MaterialBarModule,
    BsDatepickerModule.forRoot(),
    NumberPickerModule,
    MkAccordionModule,
    BoxModule,
    NgSelectModule,
    NgxFileDragDropModule,
    SharedModule,
    NgSelectModule,
    ModalModule.forRoot(),
    NgxDropzoneModule,
    TagifyModule.forRoot(),
    CollapseModule.forRoot(),
    LayoutModule.forRoot(adminLteConf),
    OrdersModule,
    DeliveryModule,
    // BranchModule
  ],
  declarations: [PageComponent, HomeComponent, ProductPromotionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class PagesModule {}
